module.exports = __webpack_public_path__ + "img/simon_zsuzsanna_reszketes_5.c383631c.jpg";